import { Component, Input, EventEmitter  } from '@angular/core';

@Component({
  selector: 'app-loader',
  template: `<div *ngIf="show" class="loader-container"> 
              <div class="loader"></div><div *ngIf="message" class="loader-message">{{message}}</div>
            </div>
            `,
  styleUrls: ['./loader.component.scss']
})


export class LoaderComponent {
  @Input() message;
  @Input() show = false
}
